{
  "name": "@wix/create-app",
  "description": "Create Wix apps",
  "version": "0.0.277",
  "author": "Ihor Machuzhak",
  "bin": "bin/index.cjs",
  "devDependencies": {
    "@commander-js/extra-typings": "^13.0.0",
    "@types/is-git-url": "^1.0.2",
    "@types/lodash": "^4.17.16",
    "@types/react": "^18.3.3",
    "@types/semver": "^7.5.8",
    "@types/validate-npm-package-name": "^4.0.2",
    "@wix/bi-logger-dev-tools-data": "^1.169.0",
    "@wix/cli-auth": "workspace:*",
    "@wix/cli-error": "workspace:*",
    "@wix/cli-error-reporting": "workspace:*",
    "@wix/cli-fs": "workspace:*",
    "@wix/cli-http-client-react": "workspace:*",
    "@wix/cli-i18n": "workspace:*",
    "@wix/cli-panorama": "workspace:*",
    "@wix/cli-telemetry": "workspace:*",
    "@wix/cli-telemetry-react": "workspace:*",
    "@wix/cli-test-overrides": "workspace:*",
    "@wix/cli-ui-kit": "workspace:*",
    "@wix/create-app-definitions": "workspace:*",
    "@wix/dev-center-client": "workspace:*",
    "@wix/gena": "workspace:*",
    "@wix/package-manager": "workspace:*",
    "@wix/tsup-configs": "workspace:*",
    "commander": "^13.0.0",
    "detect-agent": "^1.2.0",
    "globby": "^14.1.0",
    "is-git-url": "^1.0.0",
    "lodash": "^4.18.1",
    "package-json": "^10.0.1",
    "react": "^18.3.1",
    "semver": "^7.6.3",
    "tempy": "^3.1.0",
    "validate-npm-package-name": "^5.0.1",
    "variant": "^3.0.0-dev.27",
    "zod": "^3.24.2"
  },
  "engines": {
    "node": ">= 24.18.0"
  },
  "files": [
    "bin",
    "build",
    "templates"
  ],
  "homepage": "https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-cli/get-started/quick-start",
  "keywords": [
    "wix",
    "wix-cli"
  ],
  "perfer": {
    "bundleSize": {
      "files": [
        {
          "glob": "./build/index.js",
          "maxSize": "600kb"
        }
      ]
    }
  },
  "publishConfig": {
    "registry": "https://registry.npmjs.org/",
    "access": "public",
    "versionBumpStrategy": "manual",
    "logLevel": "verbose"
  },
  "scripts": {
    "build": "run -T tsup",
    "build:watch": "run -T build:watch --filter='@wix/create-app'",
    "dev:npm": "npx $INIT_CWD",
    "dev:yarn": "yarn create @wix/app@portal:$INIT_CWD",
    "test": "yarn workspace @wix/create-app-spec run test",
    "test:watch": "yarn workspace @wix/create-app-spec run test:watch",
    "typecheck": "run -T tsc --noEmit"
  },
  "type": "module",
  "wix": {
    "artifact": {
      "groupId": "com.wixpress",
      "artifactId": "wix-create-app"
    },
    "validations": {
      "postBuild": [
        "typecheck"
      ]
    }
  }
}
